export default __webpack_public_path__ + "static/media/v1.5218c1e1.webp";